import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID;
    
    // Skip if no measurement ID is configured
    if (!measurementId || measurementId === 'your-google-analytics-id-here') {
      return;
    }

    // Initialize Google Analytics if not already loaded
    if (!window.dataLayer) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = [];
      window.gtag = function gtag() {
        window.dataLayer?.push(arguments);
      }
      window.gtag('js', new Date());
      window.gtag('config', measurementId);
    }

    // Track page view on route change
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
      });
    }
  }, [location]);
}

export default useGoogleAnalytics;